import React from 'react';
import { toLower } from 'lodash';
import PropTypes from 'prop-types';
import { useIntl } from 'modules/taboola-common-frontend-modules/i18n';
import { CONVERSION_TYPE } from 'modules/tracking/config';
import { ENGAGEMENT_PREDICATE, predicateTextMap } from 'modules/tracking/config/constants';
import EllipsisCellRenderer from './EllipsisCellRenderer';
import styles from './audiencePixelBasedDetailsCellRenderer.module.scss';

export const ConversionPixelBasedDetailsCellRenderer = ({ value, data }) => {
    const { type, eventName } = data;
    const { formatMessage } = useIntl();
    let cell = '-';
    if (type === CONVERSION_TYPE.EVENT_BASED) {
        cell = formatMessage(
            {
                id: `app.campaigns.reports.grid.conversion.conditions.event`,
                defaultMessage: 'Event: {eventName}',
            },
            { eventName }
        );
    } else if (type === CONVERSION_TYPE.BASIC && value) {
        const conditions = JSON.parse(value);

        cell = conditions
            .map(condition => {
                return formatMessage(
                    {
                        id: `app.campaigns.reports.grid.conversion.conditions.prefix.${condition.conditionType.toLowerCase()}`,
                        defaultMessage: `${condition.conditionType}: {url}`,
                    },
                    { url: condition.url }
                );
            })
            .join(
                formatMessage({
                    id: `app.campaigns.reports.grid.conversion.conditions.or`,
                    defaultMessage: ' OR ',
                })
            );
    } else if (type === CONVERSION_TYPE.ENGAGEMENT && value) {
        const conditions = JSON.parse(value);
        const prefix = formatMessage({
            id: 'app.campaigns.reports.grid.conversion.conditions.engagement',
            defaultMessage: 'Engagement: ',
        });
        const isAndOperator = conditions[0]?.operator === ENGAGEMENT_PREDICATE.AND;
        const operator = formatMessage({
            id: `app.campaigns.reports.grid.conversion.conditions.${
                isAndOperator ? toLower(ENGAGEMENT_PREDICATE.AND) : toLower(ENGAGEMENT_PREDICATE.OR)
            }`,
            defaultMessage: isAndOperator
                ? ` ${toLower(ENGAGEMENT_PREDICATE.AND)} `
                : ` ${toLower(ENGAGEMENT_PREDICATE.OR)} `,
        });
        const conditionTexts = conditions.map(condition => {
            const messageInfo = predicateTextMap[condition.property]?.(condition.url);
            return messageInfo ? formatMessage(messageInfo, messageInfo.value) : '';
        });
        cell = prefix + conditionTexts.join(operator);
    }

    return (
        <div className={styles['container']} title={cell}>
            <EllipsisCellRenderer value={cell} lines={2} />
        </div>
    );
};

ConversionPixelBasedDetailsCellRenderer.propTypes = {
    value: PropTypes.string,
    data: PropTypes.shape({
        type: PropTypes.string.isRequired,
        eventName: PropTypes.string,
    }),
};
